import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { z } from "zod";

import { AuthShell } from "@/components/auth/auth-shell";
import { ResetForm } from "@/components/auth/reset-form";
import { pb } from "@/lib/pb";
import { DEFAULT_BRAND, type TenantBrand, resolveTenantBrand } from "@/lib/tenant-brand";
import { useDocumentTitle } from "@/lib/use-document-title";

const searchSchema = z.object({ token: z.string().optional() });

export const Route = createFileRoute("/resetpwd")({
  validateSearch: searchSchema,
  component: ResetPwdPage,
});

function ResetPwdPage() {
  useDocumentTitle("Reset password");
  const { token } = Route.useSearch();

  const [brand, setBrand] = useState<TenantBrand>(DEFAULT_BRAND);
  useEffect(() => {
    setBrand(resolveTenantBrand(window.location.host));
  }, []);

  async function handleSubmit({
    token,
    password,
  }: {
    token: string;
    password: string;
  }) {
    await pb.collection("auth").confirmPasswordReset(token, password, password);
  }

  return (
    <AuthShell brand={brand}>
      <ResetForm token={token ?? null} onSubmit={handleSubmit} />
    </AuthShell>
  );
}
